export default () => {
	return "https://chinapress-cloud-staging.navarch.app/api";
};
